<template>
    <section class="home-section">
        <div class="video-container">
            <!-- 背景视频 -->
            <video autoplay
                   loop
                   muted
                   playsinline
                   x5-video-player-type="h5"
                   x5-video-player-fullscreen="true"
                   x5-video-orientation="portrait"
                   class="background-video"
                   ref="backgroundVideo">
                <source src="../assets/homevideos/home.webm" type="video/webm" />
                <source src="../assets/homevideos/home.mp4" type="video/mp4" />
                您的浏览器不支持HTML5视频
            </video>

            <!-- 新增：视频封面图片 -->
            <div class="video-poster"
                 :style="{ backgroundImage: 'url(' + posterImage + ')' }"
                 v-show="showPoster"
                 @click="playVideo">
            </div>

            <!-- 响应式图片内容 -->
            <div class="video-content">
                <!-- 横向图片（PC端） -->
                <img src="../assets/home-text-horizontal.png"
                     alt="用技术解码文化 以创意重塑未来"
                     class="text-image horizontal-image"
                     ref="textImageHorizontal">

                <!-- 竖向图片（移动端） -->
                <img src="../assets/home-text-vertical.png"
                     alt="用技术解码文化 以创意重塑未来"
                     class="text-image vertical-image"
                     ref="textImageVertical">
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'HomeSection',
        data() {
            return {
                posterImage: require('../assets/home-video-poster.jpg'), // 封面图片路径
                showPoster: true // 是否显示封面
            }
        },
        mounted() {
            this.adjustVideoPosition();
            this.adjustImageSize();
            window.addEventListener('resize', this.adjustVideoPosition);
            window.addEventListener('resize', this.adjustImageSize);

            // 监听视频是否可以播放
            const video = this.$refs.backgroundVideo;
            if (video) {
                video.addEventListener('canplay', this.handleCanPlay);
                video.addEventListener('play', this.handleVideoPlay);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.adjustVideoPosition);
            window.removeEventListener('resize', this.adjustImageSize);

            const video = this.$refs.backgroundVideo;
            if (video) {
                video.removeEventListener('canplay', this.handleCanPlay);
                video.removeEventListener('play', this.handleVideoPlay);
            }
        },
        methods: {
            // 播放视频
            playVideo() {
                const video = this.$refs.backgroundVideo;
                if (video) {
                    video.play()
                        .then(() => {
                            this.showPoster = false;
                        })
                        .catch(error => {
                            console.error('视频播放失败:', error);
                            // 可以在这里添加播放失败的提示
                        });
                }
            },
            // 视频可以播放时的处理
            handleCanPlay() {
                // 可以在这里添加一些准备完成的逻辑
            },
            // 视频开始播放时的处理
            handleVideoPlay() {
                this.showPoster = false;
            },
            adjustVideoPosition() {
                const video = this.$refs.backgroundVideo;
                if (!video) return;

                if (video.readyState >= 2) {
                    this.calculateVideoPosition(video);
                } else {
                    video.addEventListener('loadedmetadata', () => {
                        this.calculateVideoPosition(video);
                    });
                }
            },
            calculateVideoPosition(video) {
                const containerRatio = window.innerWidth / (window.innerHeight - 80);
                const videoRatio = video.videoWidth / video.videoHeight;

                if (containerRatio > videoRatio) {
                    video.style.width = 'auto';
                    video.style.height = '100%';
                } else {
                    video.style.width = '100%';
                    video.style.height = 'auto';
                }
            },
            adjustImageSize() {
                const horizontalImg = this.$refs.textImageHorizontal;
                const verticalImg = this.$refs.textImageVertical;

                if (!horizontalImg || !verticalImg) return;

                const viewportWidth = window.innerWidth;

                // 768px为分界点
                if (viewportWidth > 768) { // PC端显示横向图片
                    horizontalImg.style.display = 'block';
                    verticalImg.style.display = 'none';

                    // 根据视口宽度动态调整横向图片大小
                    if (viewportWidth >= 1600) {
                        horizontalImg.style.width = '60%';
                    } else if (viewportWidth >= 1200) {
                        horizontalImg.style.width = '70%';
                    } else if (viewportWidth >= 992) {
                        horizontalImg.style.width = '80%';
                    } else {
                        horizontalImg.style.width = '90%';
                    }
                } else { // 移动端显示竖向图片
                    horizontalImg.style.display = 'none';
                    verticalImg.style.display = 'block';

                    // 根据视口宽度动态调整竖向图片大小
                    if (viewportWidth >= 576) {
                        verticalImg.style.width = '35%';
                    } else {
                        verticalImg.style.width = '35%';
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .home-section {
        height: calc(100vh - 80px);
        position: relative;
        overflow: hidden;
        margin-top: 80px;
    }

    .video-container {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .background-video {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
        z-index: 1;
    }

    /* 新增：视频封面样式 */
    .video-poster {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 2; /* 确保在视频上方 */
        cursor: pointer;
        transition: opacity 0.5s ease;
    }

    /* 图片内容样式 */
    .video-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3; /* 确保在最上层 */
        width: 100%;
        text-align: center;
    }

    .text-image {
        max-width: 30%;
        height: auto;
        transition: all 0.3s ease;
        margin: 0 180px;
    }

    /* 默认隐藏竖向图片 */
    .vertical-image {
        display: none;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .home-section {
            height: calc(100vh - 60px);
            margin-top: 60px;
        }

        /* 768px以下竖向图片居中显示 */
        .video-content {
            width: 60%;
        }

        .text-image {
            margin: 0 0px;
        }

        .horizontal-image {
            display: none;
        }

        .vertical-image {
            display: block;
        }
    }

    @media (max-width: 480px) {
        .video-content {
            width: 95%;
        }

        .text-image {
            margin: 0 55px;
        }
    }
</style>